module.exports = __webpack_public_path__ + "static/media/core.c905752b.png";